import { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import ErrorPopUp from "../../UI/ErrorPopUp";
import { useDispatch, useSelector } from "react-redux";
import { appActions } from "../../../store/appStore";
import styles from "./GroceryForm.module.css";
import useFixedBody from "../../../hooks/useFixedBody";
import { itemsActions } from "../../../store/itemStore";

const GroceryForm = () => {
  //* check if body is fixed
  useFixedBody(useSelector((state) => state.app.bodyIsFixed));
  const groceryItems = useSelector((state) => state.items.groceryItems);
  const isEditing = useSelector((state) => state.items.isEditing);
  const editDetails = useSelector((state) => state.items.editDetails);
  const dispatch = useDispatch();
  const history = useHistory();

  const [groceryItem, setGroceryItem] = useState(isEditing ? editDetails.itemName : "");
  const [error, setError] = useState("");

  // functions
  const changeItemHandler = (event) => {
    const groceryItem = event.target.value;
    setGroceryItem((prevItem) => {
      return groceryItem;
    });
  };

  const submitFormHandler = useCallback(
    (event) => {
      event.preventDefault();
      if (isEditing) {
        if (groceryItem.trim().length === 0) {
          return setError((prevError) => {
            return "please provide a value";
          });
        }
        const newItem = groceryItem;

        const newItems = groceryItems.map((groceryItem) => {
          if (groceryItem.id === editDetails.id) {
            return { id: editDetails.id, itemName: newItem };
          }
          return groceryItem;
        });
        
        dispatch(itemsActions.onSaveGroceryItems(newItems));
        localStorage.setItem("grocery-bud", JSON.stringify(newItems));

        history.push("/groceries");
        dispatch(
          itemsActions.onChangeReply({
            type: "success",
            message: "Edited Item successfully",
          })
        );
      } else {
        if (groceryItem.trim().length === 0) {
          setError((prevError) => {
            return "please provide a value";
          });
        } else {
          dispatch(itemsActions.onSaveGroceryItem({ id: Math.random(), itemName: groceryItem }));
          localStorage.setItem(
            "grocery-bud",
            JSON.stringify([{ id: Math.random(), itemName: groceryItem }, ...groceryItems])
          );
        }
      }
    },
    [dispatch, groceryItem, isEditing, editDetails, groceryItems, history]
  );

  const onSetError = () => {
    setError("");
  };
  const dispatchAppHandler = useCallback(
    ({ bodyIsFixed }) => {
      dispatch(appActions.makeBodyFixed({ bodyIsFixed }));
    },
    [dispatch]
  );

  useEffect(() => {
    if (error) {
      return dispatchAppHandler({ bodyIsFixed: true });
    }
    dispatchAppHandler({ bodyIsFixed: false });
    return () => {};
  }, [error, dispatchAppHandler]);

  return (
    <form className={styles["grocery-form"]} onSubmit={submitFormHandler}>
      <ErrorPopUp error={error} onSetError={onSetError} />
      <div className={styles["form-control"]}>
        <input
          type="text"
          placeholder="e.g eggs"
          value={groceryItem}
          onChange={changeItemHandler}
        />
      </div>

      <div className={styles["form-action"]}>
        <button type="submit">{isEditing ? "Edit" : "Submit"}</button>
      </div>
    </form>
  );
};

export default GroceryForm;
